import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../shared/services/seo-service/seo.service';

interface TicketForm {
  name: string;
  email: string;
  category: string;
  subject: string;
  description: string;
  priority: string;
}
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrl: './support.component.css',
})
export class SupportComponent {
  sidebarVisible: boolean = false;
  searchQuery: string = '';

  ticketCategories: string[] = [
    'Account & KYC',
    'Deposits & Withdrawals',
    'Trading Issues',
    'Technical Support',
    'Fees & Charges',
    'Security Concerns',
    'Platform Features',
    'Other',
  ];

  ticketForm: TicketForm = {
    name: '',
    email: '',
    category: '',
    subject: '',
    description: '',
    priority: 'medium',
  };

  constructor(
    private router: Router,
    private seo: SeoService,
  ) {}

  ngOnInit() {
    this.seo.update({
      title:
        'Coinwush Support | 24x7 Help for Crypto Futures & Options Trading',
      description:
        'Get support for your Coinwush account, trading issues, fees, margin, and platform features. Our support team assists professional traders around the clock.',
      keywords:
        'Coinwush support, crypto trading help, futures trading support, crypto exchange customer support',
      url: 'https://coinwush.com/support',
    });
  }

  navigate(route: string): void {
    this.router.navigate([route]);
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  submitTicket(event: Event): void {
    event.preventDefault();

    // Validation
    if (
      !this.ticketForm.name ||
      !this.ticketForm.email ||
      !this.ticketForm.category ||
      !this.ticketForm.subject ||
      !this.ticketForm.description
    ) {
      alert('Please fill in all required fields');
      return;
    }

    // Here you would typically send the ticket data to your backend API
    console.log('Ticket submitted:', this.ticketForm);

    // Show success message
    alert(
      'Your support ticket has been submitted successfully! We will get back to you within 24 hours.',
    );

    // Reset form
    this.resetForm();
  }

  resetForm(): void {
    this.ticketForm = {
      name: '',
      email: '',
      category: '',
      subject: '',
      description: '',
      priority: 'medium',
    };
  }
}
